import { useEffect, useRef, useState, useCallback } from "react";
import { RecordInvoiceShow, checkMeterNumber, deleteUser, getQrCode, postGroup, profileShow, refreshInvoice } from "../modules/api/RecordInvoiceAPI";
import {
  ConvertMonthTHFull,
  ConvertTime3,
} from "../modules/widgets/form/ConvertTime";
import { Tab } from "@headlessui/react";
import AmountGraph from "../modules/components/record-invoice/AmountGraph";
import UnitGraph from "../modules/components/record-invoice/UnitGraph";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toast } from 'primereact/toast';


import { Nevbar } from "../modules/layout/Navbar";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog } from "primereact/dialog";
import { toAbsoluteUrl } from "../modules/utils/AssetHelpers";
import { DetailModal, DetailModalFooter } from "../modules/components/record-invoice/DetailModal";
import { faCalendarCircleExclamation, faCalendarDays, faPlus, faDownload, faChevronRight, faTriangleExclamation, faSpinner, } from "@fortawesome/pro-solid-svg-icons";
import { faMoneyFromBracket, faCircleExclamation, faFileCircleInfo } from "@fortawesome/pro-light-svg-icons";
import { faCircleInfo, faCirclePlus, faCreditCard, faUserCircle, faTrash, faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import Swal from "sweetalert2";
import { OverlayPanel } from "primereact/overlaypanel";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

interface UserData {
  id: number;
  name: string;
  registrationNumber: string;
  phone: string;
  address: string;
  branch: string;
  route: string;
  meterArea: string;
  readingNumber: string;
}

const RecordInvoiceForm = () => {
  const toast = useRef<Toast>(null);
  const profileDataFetched = useRef(false);
  const paymentCheckIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const paymentModalVisibleRef = useRef(false);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalAmountHistory, setTotalAmountHistory] = useState(0);

  interface GroupData {
    id: number;
    name: string;
    registrationNumber: string;
    meterNumber: string;
    address: string;
    groupName?: string;
  }

  const [selectedUser, setSelectedUser] = useState<GroupData | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [usersList, setUsersList] = useState<GroupData[]>([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 992);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 992);

  // Add user modal states
  const [addUserModalVisible, setAddUserModalVisible] = useState(false);
  const [newUserRegistrationNumber, setNewUserRegistrationNumber] = useState("");
  const [newUserName, setNewUserName] = useState("");
  const [meterNumberCheckResponse, setMeterNumberCheckResponse] = useState<any>(null);
  const [isCheckingMeterNumber, setIsCheckingMeterNumber] = useState(false);
  const [meterNumberError, setMeterNumberError] = useState<string>("");
  const [meterNumberSuccess, setMeterNumberSuccess] = useState<string>("");

  // Payment modal states
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [isCheckingPayment, setIsCheckingPayment] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [groupData, setGroupData] = useState<GroupData | null>(null);
  const [userDetailModalVisible, setUserDetailModalVisible] = useState(false);
  const [selectedUserForDetail, setSelectedUserForDetail] = useState<GroupData | null>(null);
  const [deleteConfirmModalVisible, setDeleteConfirmModalVisible] = useState(false);
  const [userToDelete, setUserToDelete] = useState<GroupData | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const [user, setUser] = useState({
    // name: "",
    // registration_number: "",
    address: "",
    meter_number: "",
  });
  const [registration, setRegistration] = useState<any>(null);
  const [dataList, setDataList] = useState({
    isPaid: false,
    current_month: "",
    sumPaymentAmount: "0.00",
    overdue_months: 0,
    total_overdue_amount: "0.00",

  });
  const [charts, setCharts] = useState({
    amount: [],
    units: [],
  });


  const [visible, setVisible] = useState(false);
  const [modalData, setModalData] = useState(false);

  // Fetch profile data to get groups list
  const getProfileData = async (forceRefresh: boolean = false) => {
    // Prevent duplicate calls unless forced refresh
    if (profileDataFetched.current && !forceRefresh) {
      return;
    }

    try {
      profileDataFetched.current = true;
      const customerId = localStorage.getItem('customerId');
      const customerIdNumber = customerId ? parseInt(customerId) : 0;

      if (customerIdNumber > 0) {
        const res: any = await profileShow(customerIdNumber);
        const apiData: any = res?.data || {};

        // Set groups list from API
        const groups: GroupData[] = apiData?.groups || [];
        setUsersList(groups);

        // Set first user as selected by default
        if (groups.length > 0) {
          setSelectedUser(groups[0]);
        } else {
          // No groups found, stop loading
          setIsLoading(false);
        }
      } else {
        // No customer ID, stop loading
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
      setIsLoading(false);
      profileDataFetched.current = false; // Reset on error to allow retry
    }
  };


  const checkStatus = useCallback(async () => {
    if (!selectedUser?.id) {
      console.log('No selectedUser.id - returning false');
      return false;
    }
    try {
      const response = await refreshInvoice(selectedUser.id);
      console.log('Payment status response:', JSON.stringify(response, null, 2));

      // Check if payment is successful - only check response.data.isPaid
      // response.responseStatus is the API call status, not payment status
      let isPaid = false;

      if (!response) {
        console.log('No response received - returning false');
        return false;
      }

      // Check response.data.isPaid (this is the actual payment status)
      if (response.data && typeof response.data === 'object') {
        if (response.data.isPaid === true || response.data.isPaid === "true") {
          console.log('Found isPaid = true in response.data.isPaid');
          isPaid = true;
        } else {
          console.log('isPaid is false or not found in response.data.isPaid:', response.data.isPaid);
        }
      } else {
        console.log('response.data is not an object or does not exist');
      }

      console.log('Final isPaid result:', isPaid);
      return isPaid;
    } catch (error) {
      console.error('Error checking payment status:', error);
      return false;
    }
  }, [selectedUser?.id]);


  const getData = async () => {
    setIsLoading(true);
    const params = {
      customer_water_id: selectedUser?.id || 0,
    }
    try {
      const res: any = await RecordInvoiceShow(Number(params.customer_water_id));
      const apiData: any = res?.data || {};

      // Set user data from registration
      setUser({
        // name: apiData?.registration?.name || "",
        // registration_number: apiData?.registration?.registrationNumber || "",
        address: apiData?.registration?.address || "",
        meter_number: apiData?.registration?.meterNumber || "",
      });

      // Set registration data for details section
      setRegistration(apiData?.registration || null);

      // Set card data
      setDataList({
        isPaid: apiData?.card?.isPaid || false,
        current_month: apiData?.card?.currentMonth || "",
        sumPaymentAmount: apiData?.card?.sumPaymentAmount || "0.00",
        overdue_months: apiData?.card?.overdueMonths || 0,
        total_overdue_amount: apiData?.card?.totalOverdueAmount || 0,
      });

      // Set history data
      const historyData = apiData?.history || [];
      setData(historyData);

      // Get total amount history from API or calculate from history
      const totalFromAPI = apiData?.totalAmountHistory;
      if (totalFromAPI) {
        // Remove commas and convert to number, then format back
        const totalValue = parseFloat(totalFromAPI.toString().replace(/,/g, ''));
        setTotalAmountHistory(totalValue);
      } else {
        // Calculate total amount history if not provided by API
        const total = historyData.reduce((sum: number, item: any) => {
          const amount = typeof item.amount === 'string'
            ? parseFloat(item.amount.replace(/,/g, ''))
            : (item.amount || 0);
          return sum + amount;
        }, 0);
        setTotalAmountHistory(total);
      }

      // Set charts data
      setCharts({
        amount: apiData?.charts?.amount || [],
        units: apiData?.charts?.units || [],
      });


    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally {
      setIsLoading(false);
    }
  };




  const handleCheckMeterNumber = async () => {
    if (!newUserRegistrationNumber) {
      setMeterNumberError("กรุณากรอกเลขที่ผู้ใช้น้ำ");
      return;
    }

    setIsCheckingMeterNumber(true);
    setMeterNumberError("");
    setMeterNumberSuccess("");
    setMeterNumberCheckResponse(null);

    try {
      const response: any = await checkMeterNumber({ registrationNumber: newUserRegistrationNumber });
      setMeterNumberCheckResponse(response);

      if (response?.responseStatus === "false" || response?.responseStatus === false) {
        setMeterNumberError(response?.responseMessage || "ไม่พบเลขมาตร กรุณาตรวจสอบเลขที่ผู้ใช้น้ำ");
        setMeterNumberSuccess("");
      } else if (response?.responseStatus === "true" || response?.responseStatus === true) {
        setMeterNumberError("");
        setMeterNumberSuccess(response?.responseMessage || "ตรวจสอบเลขมาตรสำเร็จ");
      } else {
        setMeterNumberError("");
        setMeterNumberSuccess("");
      }
    } catch (error: any) {
      console.error('Error checking meter number:', error);
      setMeterNumberError("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      setMeterNumberCheckResponse({
        responseStatus: "false",
        responseMessage: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
      });
    } finally {
      setIsCheckingMeterNumber(false);
    }
  };

  const handleAddUser = async () => {
    try {
      const response: any = await postGroup({
        name: newUserName,
        registrationNumber: newUserRegistrationNumber,
      });

      // ตรวจสอบ responseStatus
      if (response?.responseStatus === "true" || response?.responseStatus === true) {
        // กรณีสำเร็จ
        toast.current?.show({
          severity: 'success',
          summary: 'สำเร็จ',
          detail: response?.responseMessage || 'เพิ่มทะเบียนผู้ใช้น้ำสำเร็จ',
          life: 3000,
        });

        // Reset form and close modal
        setNewUserRegistrationNumber("");
        setNewUserName("");
        setMeterNumberCheckResponse(null);
        setMeterNumberError("");
        setMeterNumberSuccess("");
        setAddUserModalVisible(false);

        // Refresh user list
        getProfileData(true); // Force refresh after adding user
      } else {
        // กรณีไม่สำเร็จ
        toast.current?.show({
          severity: 'error',
          summary: 'ไม่สามารถเพิ่มทะเบียนได้',
          detail: response?.responseMessage || 'กรุณาตรวจสอบข้อมูลและลองใหม่อีกครั้ง',
          life: 3000,
        });
      }
    } catch (error) {
      console.error('Error adding user:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'เกิดข้อผิดพลาด',
        detail: 'ไม่สามารถเพิ่มทะเบียนผู้ใช้น้ำได้ กรุณาลองใหม่อีกครั้ง',
        life: 3000,
      });
    }
  }


  const handlePaymentClick = async () => {

    const normalizeQrCode = (raw: string): string => {
      if (!raw) return '';

      // ตัด prefix เดิมทิ้ง
      const base64 = raw.replace(/^data:image\/\w+;base64,/, '');

      // SVG ชัดเจนมาก
      if (base64.startsWith('PD94bWwg') || base64.startsWith('<?xml')) {
        return `data:image/svg+xml;base64,${base64}`;
      }

      return `data:image/png;base64,${base64}`;
    };


    try {
      const response: any = await getQrCode(selectedUser?.id || 0);
      if (response?.responseStatus === "true" || response?.responseStatus === true) {
        // Handle both qrcode and qrCode property names, and ensure it's a valid base64 data URL
        setQrCodeUrl(normalizeQrCode(response?.data?.qrcode));
        setPaymentModalVisible(true);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'เกิดข้อผิดพลาด',
          detail: response?.responseMessage || 'ไม่สามารถรับ QR Code ได้ กรุณาลองใหม่อีกครั้ง',
          life: 3000,
        });
      }
    } catch (error) {
      console.error('Error getting QR code:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'เกิดข้อผิดพลาด',
        detail: 'ไม่สามารถรับ QR Code ได้ กรุณาลองใหม่อีกครั้ง',
        life: 3000,
      });
    }
  };

  // Function to show user detail
  const handleShowUserDetail = (user: GroupData) => {
    setSelectedUserForDetail(user);
    setUserDetailModalVisible(true);
  };

  // Function to show delete confirmation dialog
  const handleDeleteUser = (user: GroupData) => {
    setUserToDelete(user);
    setDeleteConfirmModalVisible(true);
  };

  // Function to confirm and execute delete
  const confirmDeleteUser = async () => {
    if (!userToDelete) return;

    setIsDeleting(true);
    try {
      const response: any = await deleteUser(userToDelete.id);
      if (response?.responseStatus === "true" || response?.responseStatus === true) {
        // Show success message
        toast.current?.show({
          severity: 'success',
          summary: 'สำเร็จ',
          detail: response?.responseMessage || 'ลบผู้ใช้น้ำสำเร็จ',
        });

        // Close dialog and reset state
        setDeleteConfirmModalVisible(false);
        setUserToDelete(null);

        // Refresh user list
        getProfileData(true);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: 'ไม่สามารถลบผู้ใช้น้ำได้',
          detail: response?.responseMessage || 'กรุณาลองใหม่อีกครั้ง',
        });
      }
    } catch (error) {
      console.error('Error deleting user:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'เกิดข้อผิดพลาด',
        detail: 'ไม่สามารถลบผู้ใช้น้ำได้ กรุณาลองใหม่อีกครั้ง',
        life: 3000,
      });
    } finally {
      setIsDeleting(false);
    }
  };



  useEffect(() => {
    // Only fetch if not already fetched
    if (!profileDataFetched.current) {
      getProfileData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedUser?.id) {
      getData();
    } else if (selectedUser === null && usersList.length === 0 && !profileDataFetched.current) {
      // If no user selected and no users in list, stop loading
      // Only if profile data hasn't been fetched yet
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser]);

  // Track window size for responsive design
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsTablet(width > 768 && width <= 992);
      setIsDesktop(width > 992);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      // Check if click is outside the dropdown container
      const dropdownContainer = target.closest('[data-dropdown-container]');
      if (isDropdownOpen && !dropdownContainer) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  // Update ref when paymentModalVisible changes
  useEffect(() => {
    paymentModalVisibleRef.current = paymentModalVisible;
  }, [paymentModalVisible]);

  // Check payment status every 5 seconds when payment modal is open
  useEffect(() => {
    if (paymentModalVisible && selectedUser?.id) {
      setIsCheckingPayment(true);

      // Helper function to handle successful payment
      const handlePaymentSuccess = async () => {
        // Double check that modal is still visible before closing (using ref for latest value)
        if (!paymentModalVisibleRef.current) {
          console.log('Modal already closed - skipping payment success handler');
          return;
        }

        console.log('Payment successful - closing dialog');
        if (paymentCheckIntervalRef.current) {
          clearInterval(paymentCheckIntervalRef.current);
          paymentCheckIntervalRef.current = null;
        }
        setIsCheckingPayment(false);
        setPaymentModalVisible(false);

        // Show success message with Swal
        await Swal.fire({
          icon: 'success',
          title: 'ชำระเงินสำเร็จ!',
          text: 'ชำระเงินเรียบร้อยแล้ว',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#01A867',
        });

        // Refresh data after successful payment
        getData();
      };

      // First check immediately
      checkStatus().then((isPaid) => {
        console.log('First check result - isPaid:', isPaid, 'type:', typeof isPaid);

        // Strict check: only proceed if isPaid is explicitly true
        if (isPaid === true) {
          // Payment successful - close modal and refresh data
          handlePaymentSuccess();
          return; // Exit early if payment is already successful
        }

        // Payment not yet - set up interval to check every 5 seconds
        console.log('Payment not yet - setting up interval check');
        paymentCheckIntervalRef.current = setInterval(async () => {
          // Check if modal is still visible before checking status (using ref for latest value)
          if (!paymentModalVisibleRef.current) {
            console.log('Modal closed - stopping interval check');
            if (paymentCheckIntervalRef.current) {
              clearInterval(paymentCheckIntervalRef.current);
              paymentCheckIntervalRef.current = null;
            }
            return;
          }

          const isPaid = await checkStatus();
          console.log('Interval check result - isPaid:', isPaid, 'type:', typeof isPaid);

          // Strict check: only proceed if isPaid is explicitly true
          if (isPaid === true) {
            // Payment successful - stop checking, close modal and refresh data
            handlePaymentSuccess();
          } else {
            // Payment not yet - keep modal open and continue checking
            console.log('Payment still not completed - continuing check');
            // Modal stays open, interval will continue
          }
        }, 5000); // Check every 5 seconds
      }).catch((error) => {
        console.error('Error in first payment check:', error);
        setIsCheckingPayment(false);
      });
    } else {
      // If modal is not visible, make sure to clean up
      if (paymentCheckIntervalRef.current) {
        clearInterval(paymentCheckIntervalRef.current);
        paymentCheckIntervalRef.current = null;
      }
      setIsCheckingPayment(false);
    }

    return () => {
      console.log('Cleaning up payment check interval');
      if (paymentCheckIntervalRef.current) {
        clearInterval(paymentCheckIntervalRef.current);
        paymentCheckIntervalRef.current = null;
      }
      setIsCheckingPayment(false);
    };
  }, [paymentModalVisible, selectedUser?.id, checkStatus]);

  return (
    <>
      <Toast ref={toast} position="top-right" className="toast-anuphan" />
      {/* <OverlayPanel ref={overlayPanelRef} visible={overlayPanelVisible} onHide={() => setOverlayPanelVisible(false)}>
        <div>
          <h5>รายละเอียด</h5>

         
      </OverlayPanel> */}


      {/* User Detail Modal */}
      < Dialog
        visible={userDetailModalVisible}
        onHide={() => {
          setUserDetailModalVisible(false);
          setSelectedUserForDetail(null);
        }}
        header={
          < div className="fw-medium" style={{ fontSize: '18px', color: '#2C2C2C', fontFamily: 'google sans, sans-serif' }}> รายละเอียดผู้ใช้น้ำ</div >
        }
        style={{ width: '90vw', maxWidth: '500px' }}
        className="custom-modal"
      >
        {selectedUserForDetail && (
          <div style={{ fontFamily: 'Google Sans, sans-serif' }}>
            <div className="mb-3">
              <div className=" mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>ชื่อผู้ใช้น้ำ</div>
              <div style={{ fontSize: '16px', color: '#2C2C2C' }}>{selectedUserForDetail.groupName && selectedUserForDetail.groupName !== "-" ? selectedUserForDetail.groupName : selectedUserForDetail.name}</div>
            </div>
            <div className="mb-3">
              <div className=" mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>เลขที่ผู้ใช้น้ำ</div>
              <div style={{ fontSize: '16px', color: '#2C2C2C' }}>{selectedUserForDetail.registrationNumber}</div>
            </div>
            <div className="mb-3">
              <div className=" mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>เลขมาตร</div>
              <div style={{ fontSize: '16px', color: '#4263B5' }}>{selectedUserForDetail.meterNumber}</div>
            </div>
            <div className="mb-3">
              <div className=" mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>ที่อยู่</div>
              <div style={{ fontSize: '16px', color: '#2C2C2C' }}>{selectedUserForDetail.address}</div>
            </div>
            {registration && selectedUserForDetail.id === selectedUser?.id && (
              <>
                <hr className="my-3" />
                <div className="mb-3">
                  <div className=" mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>สาขา</div>
                  <div style={{ fontSize: '16px', color: '#2C2C2C' }}>{registration.branchName || "-"}</div>
                </div>
                <div className="mb-3">
                  <div className=" mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>แนวเส้นท่อ</div>
                  <div style={{ fontSize: '16px', color: '#2C2C2C' }}>{registration.dmaTitle || "-"}</div>
                </div>
                <div className="mb-3">
                  <div className=" mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>พื้นที่อ่านมาตร</div>
                  <div style={{ fontSize: '16px', color: '#2C2C2C' }}>{registration.meterReadingAreaTitle || "-"}</div>
                </div>
                <div className="mb-3">
                  <div className=" mb-1" style={{ fontSize: '14px', opacity: '0.5' }}>เส้นทางอ่านมาตร</div>
                  <div style={{ fontSize: '16px', color: '#2C2C2C' }}>{registration.readingRouteName || "-"}</div>
                </div>
              </>
            )}
          </div>
        )}
      </Dialog >

      {/* Delete Confirmation Dialog */}
      <Dialog
        visible={deleteConfirmModalVisible}
        onHide={() => {
          if (!isDeleting) {
            setDeleteConfirmModalVisible(false);
            setUserToDelete(null);
          }
        }}
        header={null}
        style={{ width: '90vw', maxWidth: '500px' }}
        className="custom-modal p-0"
        closable={!isDeleting}
        closeOnEscape={!isDeleting}
      >
        <div className="text-center mt-3 mt-md-0" style={{ fontFamily: 'Google Sans, sans-serif' }}>
          <div className="d-flex justify-content-center mb-4">
            <FontAwesomeIcon icon={faTriangleExclamation} style={{ fontSize: '48px', color: '#DC3545', marginBottom: '8px', backgroundColor: '#fbe2e6', borderRadius: '50%', padding: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />

          </div>

          <div className="mb-2">
            <p style={{ fontSize: '16px', color: '#2C2C2C', marginBottom: '8px' }}>
              คุณต้องการลบผู้ใช้น้ำ
            </p>
            <p style={{ fontSize: '18px', color: '#2C2C2C', fontWeight: '500' }}>
              "{userToDelete && (userToDelete.groupName && userToDelete.groupName !== "-" ? userToDelete.groupName : userToDelete.name)}"
            </p>
            <p style={{ fontSize: '14px', color: '#6F6B7D', marginTop: '8px' }}>
              หรือไม่? การกระทำนี้ไม่สามารถยกเลิกได้
            </p>
          </div>

          <div className="d-flex justify-content-center gap-2">
            <button
              onClick={() => {
                if (!isDeleting) {
                  setDeleteConfirmModalVisible(false);
                  setUserToDelete(null);
                }
              }}
              disabled={isDeleting}
              style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #E0E0E0',
                borderRadius: '8px',
                padding: '10px 20px',
                fontSize: '14px',
                color: '#2C2C2C',
                fontFamily: 'google sans, sans-serif',
                cursor: isDeleting ? 'not-allowed' : 'pointer',
                opacity: isDeleting ? 0.5 : 1,
                display: 'flex',
                alignItems: 'center',
                width: '100px',
                justifyContent: 'center',
              }}
            >
              ยกเลิก
            </button>
            <button
              onClick={confirmDeleteUser}
              disabled={isDeleting}
              style={{
                backgroundColor: '#DC3545',
                border: 'none',
                borderRadius: '8px',
                padding: '10px 20px',
                fontSize: '14px',
                color: '#FFFFFF',
                fontFamily: 'google sans, sans-serif',
                cursor: isDeleting ? 'not-allowed' : 'pointer',
                opacity: isDeleting ? 0.7 : 1,
                display: 'flex',
                alignItems: 'center',
                width: '100px',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              {isDeleting && (
                <FontAwesomeIcon icon={faSpinner} className="me-2" spin={true} />
              )}
              <FontAwesomeIcon icon={faTrash} style={{ fontSize: '16px', color: '#FFFFFF' }} />

              {isDeleting ? 'กำลังลบ...' : 'ลบ'}
            </button>
          </div>
        </div>
      </Dialog>

      {
        isLoading ? (
          <>
            <Nevbar />
            <div className="center-screen-2">
              <FontAwesomeIcon icon={faSpinner} className="me-2" spin={true} />
              <span>กำลังดึงข้อมูล...</span>
            </div>
          </>
        ) : (
          <>
            <div
              className="bg-white"
            // style={{
            //   backgroundImage: `url('${toAbsoluteUrl("/images/bg-2.svg")}')`,
            // }}
            >
              <Nevbar />
              <div className="container">
                <div className="row">
                  <div className="col-12 mb-0 mb-md-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="  d-flex flex-column" style={{ borderRadius: '12px', backgroundColor: '#FFFFFF', position: 'relative' }}>

                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-3 mt-3 mb-0 mb-md-2 px-0 px-md-0">

                            <div className="d-flex flex-column flex-md-column flex-lg-row gap-3 col-12 col-md-12 col-lg-6 pe-0 pe-md-0 pe-lg-3" data-dropdown-container style={{ position: 'relative', minWidth: 'fit-content' }}>
                              <div className="flex-grow-1" style={{ position: 'relative', minWidth: 0 }}>
                                <div
                                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                  style={{
                                    padding: isMobile ? '12px 16px' : '12px 16px',
                                    border: '1px solid #E0E0E0',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    cursor: 'pointer',
                                    position: 'relative',
                                    width: '100%',
                                    maxHeight: isMobile ? '64px' : '56px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    minWidth: 'fit-content'
                                  }}
                                >
                                  <div className="d-flex align-items-center w-100 justify-content-between">
                                    <div className=" d-flex align-items-center" style={{ minWidth: 0, paddingRight: '8px', height: '56px' }}>
                                      {selectedUser ? (
                                        <div className="fw-medium d-flex flex-column flex-md-row gap-0 gap-md-2 align-items-start align-items-md-center " style={{ fontSize: isMobile ? '13px' : '16px', color: '#2C2C2C' }}>
                                          <span style={{ color: '#4263B5', fontSize: isMobile ? '14px' : '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>เลขที่ผู้ใช้น้ำ : {selectedUser.registrationNumber}</span>
                                          <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: isMobile ? '12px' : '14px', color: '#4263B5', display: isMobile || isTablet ? 'none' : 'block' }} />
                                          <span style={{ color: '#2C2C2C', fontSize: isMobile ? '16px' : '16px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{selectedUser.groupName && selectedUser.groupName !== "-" ? selectedUser.groupName : selectedUser.name}</span>
                                        </div>
                                      ) : (
                                        <div style={{ fontSize: isMobile ? '13px' : '14px', color: '#9E9E9E' }}>เลือกผู้ใช้น้ำ</div>
                                      )}
                                    </div>
                                    <div className="ms-2 flex-shrink-0">
                                      <svg width={isMobile ? "16" : "20"} height={isMobile ? "16" : "20"} viewBox="0 0 20 20" fill="none" style={{ transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }}>
                                        <path d="M5 7.5L10 12.5L15 7.5" stroke={selectedUser ? "#6F6B7D" : "#9E9E9E"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>

                                {/* Dropdown Menu */}
                                {isDropdownOpen && (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      top: '100%',
                                      left: 0,
                                      right: 0,
                                      marginTop: '4px',
                                      backgroundColor: '#FFFFFF',
                                      border: '1px solid #E0E0E0',
                                      borderRadius: '8px',
                                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                      zIndex: 1000,
                                      maxHeight: isMobile ? '300px' : '400px',
                                      overflowY: 'auto'
                                    }}
                                  >
                                    {usersList.length > 0 ? (
                                      usersList.map((user) => (
                                        <div
                                          key={user.id}
                                          style={{
                                            padding: isMobile ? '10px 12px' : '12px 16px',
                                            borderBottom: '1px solid #F0F0F0',
                                            backgroundColor: selectedUser?.id === user.id ? '#F8F9FA' : '#FFFFFF',
                                            transition: 'background-color 0.2s'
                                          }}
                                          onMouseEnter={(e) => {
                                            if (selectedUser?.id !== user.id) {
                                              e.currentTarget.style.backgroundColor = '#F8F9FA';
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (selectedUser?.id !== user.id) {
                                              e.currentTarget.style.backgroundColor = '#FFFFFF';
                                            }
                                          }}
                                        >
                                          <div className="d-flex justify-content-between align-items-start">
                                            <div
                                              className="flex-grow-1"
                                              onClick={() => {
                                                setSelectedUser(user);
                                                setIsDropdownOpen(false);
                                                // getData() will be called automatically by useEffect when selectedUser changes
                                              }}
                                              style={{ cursor: 'pointer', minWidth: 0 }}
                                            >
                                              <div className="fw-medium d-flex flex-column" style={{ fontSize: isMobile ? '13px' : '16px', color: '#2C2C2C', marginBottom: '4px' }}>
                                                <span style={{ color: '#4263B5', fontSize: isMobile ? '11px' : '14px' }}>เลขที่ผู้ใช้น้ำ : {user.registrationNumber}</span>
                                                <span style={{ color: '#2C2C2C', fontSize: isMobile ? '15px' : '18px' }}>{user.groupName && user.groupName !== "-" ? user.groupName : user.name}</span>
                                              </div>
                                              <div style={{ fontSize: isMobile ? '12px' : '14px', color: '#6F6B7D' }}>{user.address}</div>
                                            </div>
                                            <div className="d-flex gap-2 ms-3 flex-shrink-0">
                                              <button
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleDeleteUser(user);
                                                }}
                                                style={{
                                                  backgroundColor: '#DC3545',
                                                  color: '#FFFFFF',
                                                  border: 'none',
                                                  borderRadius: '6px',
                                                  padding: isMobile ? '5px 10px' : '6px 12px',
                                                  fontSize: isMobile ? '11px' : '12px',
                                                  cursor: 'pointer',
                                                  fontFamily: 'google sans, sans-serif'
                                                }}
                                              >
                                                <FontAwesomeIcon icon={faTrash} style={{ fontSize: isMobile ? '11px' : '12px', color: '#FFFFFF' }} />
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="text-center py-4" style={{ color: '#9E9E9E', fontFamily: 'google sans, sans-serif', fontSize: isMobile ? '13px' : '14px' }}>
                                        ไม่มีรายชื่อผู้ใช้น้ำ
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                              <div className="row">
                                <div className="col-6 col-md d-flex align-items-center">
                                  <button
                                    onClick={() => {
                                      if (selectedUser) {
                                        handleShowUserDetail(selectedUser as GroupData);
                                      }
                                    }}
                                    disabled={!selectedUser}
                                    style={{
                                      backgroundColor: '#FFFFFF',
                                      border: 'none',
                                      boxShadow: 'inset 0 0 0 1px #4263B5',
                                      borderRadius: '8px',
                                      padding: isMobile ? '10px 14px' : '10px 20px',
                                      fontSize: isMobile ? '12px' : '14px',
                                      color: '#4263B5',
                                      fontFamily: 'google sans, sans-serif',
                                      cursor: selectedUser ? 'pointer' : 'not-allowed',
                                      opacity: selectedUser ? 1 : 0.5,
                                      whiteSpace: 'nowrap',
                                      display: 'flex',
                                      fontWeight: '400',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      width: (isMobile || isTablet) ? '100%' : 'auto',
                                      minWidth: 'fit-content',
                                      height: isMobile ? '32px' : '56px'
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faCircleInfo} style={{ fontSize: isMobile ? '14px' : '16px', color: '#4263B5', marginRight: '6px' }} />
                                    <span className="">ดูรายละเอียด</span>
                                  </button>
                                </div>

                                <div className="col-6 col-md d-flex align-items-center">
                                  {(isMobile || isTablet) && (
                                    <button
                                      onClick={() => setAddUserModalVisible(true)}
                                      style={{
                                        background: 'linear-gradient(135deg, #547DE5 0%, #2F457F 100%)',
                                        color: '#FFFFFF',
                                        padding: isMobile ? '10px 14px' : '10px 20px',
                                        borderRadius: '8px',
                                        border: 'none',
                                        fontSize: isMobile ? '12px' : '14px',
                                        fontWeight: '400',
                                        whiteSpace: 'nowrap',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: (isMobile || isTablet) ? '100%' : 'auto',
                                        minWidth: 'fit-content',
                                        height: isMobile ? '32px' : '56px'
                                      }}
                                    >
                                      <svg width={isMobile ? "18" : "20"} height={isMobile ? "18" : "20"} viewBox="0 0 20 20" fill="none" style={{ marginRight: '6px' }}>
                                        <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5" />
                                        <path d="M10 6V14M6 10H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                      </svg>
                                      <span >เพิ่มเลขที่ผู้ใช้น้ำ</span>
                                    </button>
                                  )}
                                </div>
                              </div>
                              {/* Detail Button */}



                            </div>

                            {/* Right: Add button */}
                            <div className="d-flex justify-content-end h-100">
                              {isDesktop && (
                                <button
                                  className="btn d-flex align-items-center justify-content-center"
                                  onClick={() => setAddUserModalVisible(true)}
                                  style={{
                                    background: 'linear-gradient(135deg, #547DE5 0%, #2F457F 100%)',
                                    color: '#FFFFFF',
                                    padding: '10px 20px',
                                    borderRadius: '10px',
                                    border: 'none',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    whiteSpace: 'nowrap',
                                    width: 'auto',
                                    minWidth: 'fit-content',
                                    minHeight: '56px'
                                  }}
                                >
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: '6px' }}>
                                    <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5" />
                                    <path d="M10 6V14M6 10H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                  </svg>
                                  <span >เพิ่มเลขที่ผู้ใช้น้ำ</span>

                                </button>
                              )}
                            </div>

                          </div>

                          {/* Details section */}

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 h-100">
                    <div className="row">
                      <div className="col-6 mb-4">
                        <div
                          className="text-white custom-card-2 bg-invoice-crad shadow-sm "
                          style={{
                            backgroundImage: `url('${toAbsoluteUrl(
                              "/images/crads/1.svg"
                            )}')`,
                          }}
                        >
                          <div className="">
                            <FontAwesomeIcon
                              icon={faCalendarDays}
                              style={{ fontSize: "32px" }}
                            />
                          </div>
                          <div className="d-flex align-text-top flex-column justify-content-end" style={{ height: "100%" }}>
                            <div className="fs-6" style={{ color: "rgba(255, 255, 255, 0.8)" }}>
                              เดือนปัจจุบัน
                            </div>
                            <div className="fs-2 fw-medium ">
                              {dataList?.current_month ? ConvertMonthTHFull(dataList.current_month) : ""}
                            </div>
                          </div>

                        </div>
                      </div>
                      <div className="col mb-4">
                        <div
                          className="text-6F6B7D custom-card-2 bg-invoice-crad border border-2"
                        >
                          <div className="mb-2 d-flex flex-column flex-md-row justify-content-between align-items-center w-100">
                            <div className="d-flex justify-content-start w-100 w-md-auto mb-2 mb-md-0">
                              <FontAwesomeIcon
                                icon={faMoneyFromBracket}
                                style={{ fontSize: "32px", color: "#10B981" }}
                              />
                            </div>

                            <div className=" justify-content-end w-100 w-md-auto d-none d-md-flex">
                              {dataList?.isPaid === false && (

                                <button
                                  onClick={handlePaymentClick}
                                  className="payment-button w-100 w-md-auto"
                                >
                                  <FontAwesomeIcon icon={faCreditCard} className="me-2" />
                                  <span>ชำระเงิน</span>
                                </button>
                              )}
                            </div>

                          </div>
                          <div className="d-flex align-text-top flex-column justify-content-end" style={{ height: "100%" }}>
                            <div className="fs-6" style={{ color: "#9E9E9E" }}>
                              ยอดชำระ
                            </div>
                            <div className="fs-2 fw-medium mt-1 " style={{ color: "#10B981" }}>
                              {dataList?.sumPaymentAmount || 0} <span className="fs-5">฿</span>
                            </div>
                          </div>
                          <div className=" justify-content-end w-100 w-md-auto d-flex d-md-none">
                            {dataList?.isPaid === false && (

                              <button
                                onClick={handlePaymentClick}
                                className="payment-button w-100 w-md-auto"
                              >
                                <FontAwesomeIcon icon={faCreditCard} className="me-2" />
                                <span>ชำระเงิน</span>
                              </button>
                            )}
                          </div>

                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <div
                          className="custom-card-2 bg-invoice-crad "
                          style={{
                            backgroundImage: `url('${toAbsoluteUrl(
                              "/images/crads/2.svg"
                            )}')`,
                            color: "#4263B5",
                          }}
                        >
                          <div className="mb-2">
                            <FontAwesomeIcon
                              icon={faCalendarCircleExclamation}
                              style={{ fontSize: "32px" }}
                            />
                          </div>
                          <div className="d-flex align-text-top flex-column justify-content-end" style={{ height: "100%" }}>
                            <div className="fs-6" style={{ color: "rgba(66, 99, 181, 0.7)" }}>
                              จำนวนเดือนที่ค้างชำระ
                            </div>
                            <div className="fs-2 fw-medium mt-1">
                              {dataList?.overdue_months || 0} <span className="fs-5">เดือน</span>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div className="col-6 mb-2">
                        <div
                          className="text-6F6B7D custom-card-2 bg-invoice-crad border border-2"
                        >
                          <div className="mb-2 d-flex justify-content-start align-items-center w-100">
                            <FontAwesomeIcon
                              icon={faCircleExclamation}
                              style={{ fontSize: "32px", color: "#DC3545" }}
                            />

                          </div>
                          <div className="d-flex align-text-top flex-column justify-content-end" style={{ height: "100%" }}>
                            <div className="fs-6" style={{ color: "#9E9E9E" }}>
                              ยอดค้างชำระ
                            </div>
                            <div className="fs-2 fw-medium mt-1 text-danger">
                              {dataList?.total_overdue_amount || 0} <span className="fs-5">฿</span>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 mb-3 lg:mb-0">
                    <div className="card-body p-3 border border-2 mt-2 mt-lg-0">
                      <div>
                        <Tab.Group>
                          <Tab.List className="mb-2">
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="d-flex align-items-center text-tab">
                                <div className="text-6F6B7D me-2 fs-6">
                                  ข้อมูลผู้ใช้น้ำ
                                </div>
                                <Tab
                                  className={({ selected }) =>
                                    classNames(
                                      "fs-6 me-2",
                                      selected ? "btn-tab-seleted-2 px-3" : "btn-tab-2 px-3"
                                    )
                                  }
                                >
                                  <span style={{ fontSize: '14px' }}>จำนวนเงิน</span>
                                </Tab>
                                <Tab
                                  className={({ selected }) =>
                                    classNames(
                                      "fs-6",
                                      selected ? "btn-tab-seleted-2 px-3" : "btn-tab-2 px-3"
                                    )
                                  }
                                >
                                  <span style={{ fontSize: '14px' }}>จำนวนหน่วย</span>
                                </Tab>
                              </div>
                              <button className="btn btn-sm">
                                <FontAwesomeIcon icon={['far', 'ellipsis-vertical']} />
                              </button>
                            </div>
                          </Tab.List>
                          <Tab.Panels>
                            <Tab.Panel>
                              <AmountGraph data={charts.amount} />
                            </Tab.Panel>
                            <Tab.Panel>
                              <UnitGraph data={charts.units} />
                            </Tab.Panel>
                          </Tab.Panels>
                        </Tab.Group>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 mb-3 mt-2">
                    <div className="card border border-2" style={{ borderRadius: "12px", overflow: "hidden" }}>
                      <div className="card-body p-4">
                        <div className="mb-3">
                          <h4 className="mb-1 fw-bold" style={{ color: "#2C2C2C" }}>
                            ประวัติการชำระเงิน
                          </h4>
                          <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                            รายละเอียดการชำระเงิน
                          </p>
                        </div>
                        <div className="table-responsive">
                          <table
                            className="table table-hover text-center mb-0"
                            style={{ minWidth: "500px" }}
                          >
                            <thead style={{ backgroundColor: "#F8F9FA", borderBottom: "2px solid #E9ECEF" }}>
                              <tr>
                                <th className="py-3" style={{ color: "#6F6B7D", fontWeight: "600", minWidth: "100px", fontSize: "14px" }}>รอบบิล</th>
                                <th className="py-3" style={{ color: "#6F6B7D", fontWeight: "600", minWidth: "160px", fontSize: "14px" }}>วันที่จดหน่วย</th>
                                <th className="py-3" style={{ color: "#6F6B7D", fontWeight: "600", minWidth: "100px", fontSize: "14px" }}>หน่วยน้ำ</th>
                                <th className="py-3" style={{ color: "#6F6B7D", fontWeight: "600", minWidth: "160px", fontSize: "14px" }}>วันที่ชำระ</th>
                                <th className="py-3" style={{ color: "#6F6B7D", fontWeight: "600", minWidth: "100px", fontSize: "14px" }}>ราคา(บาท)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.length > 0
                                ? data?.map((val: any, index: number) => {
                                  return (
                                    <tr
                                      key={`table_${index}`}
                                      onClick={() => {
                                        setModalData(val);
                                        setVisible(true);
                                      }}
                                      style={{ cursor: "pointer", borderBottom: "1px solid #F0F0F0" }}
                                    >
                                      <td className="py-3" style={{ color: "#6F6B7D" }}>{val.month ? (val.month) : "-"}</td>
                                      <td className="py-3" style={{ color: "#6F6B7D" }}>
                                        {val?.readingDate
                                          ? (val.readingDate)
                                          : "-"}
                                      </td>
                                      <td className="py-3" style={{ color: "#6F6B7D", }}> <span className="text-end">{val.units ? (val.units) : "-"}</span></td>

                                      <td className="py-3" style={{ color: "#6F6B7D" }}>
                                        {val?.paymentDate && val.paymentDate !== "-" ? (val.paymentDate) : <span className="text-danger bg-danger-subtle p-1 px-2 rounded-2">ยังไม่ได้ชำระ</span>}
                                      </td>
                                      <td className="py-3" style={{ color: "#6F6B7D" }}>{val.amount || 0}</td>
                                    </tr>
                                  );
                                })
                                : null}
                            </tbody>
                          </table>
                        </div>
                        {/* Summary Row - Outside table but inside card */}
                        {data?.length > 0 && (
                          <div
                            className="d-flex justify-content-between align-items-center mt-3 p-3"
                            style={{
                              backgroundColor: "#F8F9FA",
                              borderTop: "2px solid #E9ECEF",
                              borderRadius: "0 0 12px 12px"
                            }}
                          >
                            <div className="fw-bold" style={{ color: "#2C2C2C", fontSize: "16px" }}>
                              สรุปรวม
                            </div>
                            <div className="fw-bold" style={{ color: "#2C2C2C", fontSize: "16px" }}>
                              {totalAmountHistory.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} <span className="fs-6">บาท</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }
      {/* Detail modal */}
      <Dialog
        header={
          <>
            <div
              className="fs-5"
            >
              รายละเอียดการใช้น้ำ
              <hr />
            </div>
          </>
        }
        visible={visible}
        className="custom-modal"
        style={{ width: '90vw', maxWidth: '400px' }}
        onHide={() => setVisible(false)}
        footer={<DetailModalFooter data={modalData} />}
      >
        <DetailModal data={modalData} registration={registration} historyData={data} />
      </Dialog>

      {/* Add User Modal */}
      <Dialog
        visible={addUserModalVisible}
        header={
          <div className="fs-5">
            เพิ่มเลขที่ผู้ใช้น้ำ
          </div>
        }
        className="custom-modal"
        style={{ width: '90vw', maxWidth: '500px' }}
        onHide={() => {
          setAddUserModalVisible(false);
          setNewUserRegistrationNumber("");
          setNewUserName("");
          setMeterNumberCheckResponse(null);
          setMeterNumberError("");
          setMeterNumberSuccess("");
        }}
      >
        <div className="p-3" style={{ fontFamily: 'google sans, sans-serif' }}>


          <div className="mb-3">
            <label htmlFor="registrationNumber" className="form-label fw-medium" style={{ fontSize: '14px', color: '#2C2C2C', fontFamily: 'google sans, sans-serif' }}>
              เลขที่ผู้ใช้น้ำ <span className="text-danger">*</span>
            </label>
            <div className="d-flex flex-column gap-2">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <input
                  type="text"
                  className="form-control"
                  id="registrationNumber"
                  value={newUserRegistrationNumber}
                  onChange={(e) => {
                    setNewUserRegistrationNumber(e.target.value);
                    // Reset check response when registration number changes
                    setMeterNumberCheckResponse(null);
                    setMeterNumberError("");
                    setMeterNumberSuccess("");
                  }}
                  placeholder="กรอกเลขที่ผู้ใช้น้ำ"
                  style={{
                    padding: '10px 14px',
                    fontSize: '14px',
                    borderRadius: '8px',
                    border: meterNumberError ? '1px solid #DC3545' : '1px solid #E0E0E0',
                    fontFamily: 'google sans, sans-serif'
                  }}
                />
                <button
                  className="btn w-100 d-flex align-items-center justify-content-center"
                  onClick={handleCheckMeterNumber}
                  disabled={!newUserRegistrationNumber || isCheckingMeterNumber}
                  style={{
                    backgroundColor: (!newUserRegistrationNumber || isCheckingMeterNumber) ? '#9E9E9E' : '#4263B5',
                    color: '#FFFFFF',
                    padding: '10px 10px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    maxWidth: '140px',
                    fontWeight: '500',
                    border: 'none',
                    cursor: (!newUserRegistrationNumber || isCheckingMeterNumber) ? 'not-allowed' : 'pointer',
                    fontFamily: 'google sans, sans-serif'
                  }}
                >
                  {isCheckingMeterNumber ? 'กำลังตรวจสอบ...' : 'ตรวจสอบเลขผู้ใช้น้ำ'}
                </button>
              </div>
              {!meterNumberError && (
                <div>
                  <FontAwesomeIcon icon={faInfoCircle} className="me-2 opacity-50" />
                  <small className="opacity-50" style={{ fontFamily: 'google sans, sans-serif', fontSize: '12px' }}>ตรวจสอบเลขผู้ใช้น้ำที่มีอยู่</small>
                </div>
              )}
              {meterNumberError && (
                <small className="text-danger" style={{ fontFamily: 'google sans, sans-serif', fontSize: '12px' }}>
                  {meterNumberError}
                </small>
              )}
              {meterNumberSuccess && !meterNumberError && (
                <small className="" style={{ fontFamily: 'google sans, sans-serif', fontSize: '12px', color: '#10b981' }}>
                  {meterNumberSuccess}
                </small>
              )}
            </div>

          </div>

          <div className="mb-4">
            <label htmlFor="userName" className="form-label fw-medium" style={{ fontSize: '14px', color: '#2C2C2C', fontFamily: 'google sans, sans-serif' }}>
              ตั้งชื่อผู้ใช้น้ำ
            </label>
            <input
              type="text"
              className="form-control"
              id="userName"
              value={newUserName}
              onChange={(e) => setNewUserName(e.target.value)}
              placeholder="เช่น พี่สมชาย"
              disabled={!meterNumberCheckResponse || meterNumberCheckResponse?.responseStatus === "false" || meterNumberCheckResponse?.responseStatus === false}
              style={{
                padding: '10px 14px',
                fontSize: '14px',
                borderRadius: '8px',
                border: '1px solid #E0E0E0',
                fontFamily: 'google sans, sans-serif',
                backgroundColor: (!meterNumberCheckResponse || meterNumberCheckResponse?.responseStatus === "false" || meterNumberCheckResponse?.responseStatus === false) ? '#F5F5F5' : '#FFFFFF',
                cursor: (!meterNumberCheckResponse || meterNumberCheckResponse?.responseStatus === "false" || meterNumberCheckResponse?.responseStatus === false) ? 'not-allowed' : 'text'
              }}
            />
          </div>

          <button
            className="btn w-100 d-flex align-items-center justify-content-center"
            onClick={handleAddUser}
            disabled={!newUserRegistrationNumber || !meterNumberCheckResponse || meterNumberCheckResponse?.responseStatus === "false" || meterNumberCheckResponse?.responseStatus === false}
            style={{
              backgroundColor: (!newUserRegistrationNumber || !meterNumberCheckResponse || meterNumberCheckResponse?.responseStatus === "false" || meterNumberCheckResponse?.responseStatus === false) ? '#9E9E9E' : '#4263B5',
              color: '#FFFFFF',
              padding: '12px 20px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              border: 'none',
              cursor: (!newUserRegistrationNumber || !meterNumberCheckResponse || meterNumberCheckResponse?.responseStatus === "false" || meterNumberCheckResponse?.responseStatus === false) ? 'not-allowed' : 'pointer',
              fontFamily: 'Google Sans'
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ marginRight: '8px' }}>
              <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5" />
              <path d="M10 6V14M6 10H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <span>เพิ่มเลขที่ผู้ใช้น้ำ</span>
          </button>
        </div>
      </Dialog>

      {/* Payment Modal */}
      <Dialog
        visible={paymentModalVisible}
        header={
          <div className="fs-5">
            การชำระเงิน
          </div>
        }
        className="custom-modal"
        style={{ width: '90vw', maxWidth: '450px', height: 'fit-content' }}
        onHide={() => {
          setPaymentModalVisible(false);
          setIsCheckingPayment(false);
        }}
      >
        <div className="p-3 text-center" style={{ fontFamily: 'google sans, sans-serif' }}>
          <h5 className="mb-3 fw-bold" style={{ color: '#2C2C2C', fontFamily: 'google sans, sans-serif' }}>
            ชำระเงินผ่าน QR Code
          </h5>

          <p className="text-6F6B7D mb-4" style={{ fontSize: '14px', fontFamily: 'google sans, sans-serif' }}>
            สแกน QR Code เพื่อชำระเงิน
          </p>

          {/* QR Code Display */}
          <div className="d-flex justify-content-center mb-4">
            <div
              style={{
                width: '280px',
                height: '280px',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#F8F9FA'
              }}
            >
              {qrCodeUrl ? (
                <img
                  src={qrCodeUrl}
                  alt="QR Code"
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              ) : (
                <div style={{ color: '#9E9E9E', fontFamily: 'google sans, sans-serif' }}>กำลังโหลด QR Code...</div>
              )}
            </div>
          </div>
          {isCheckingPayment && (
            <div className="w-100 d-flex align-items-center justify-content-center opacity-50" style={{ marginTop: '16px', marginBottom: '16px' }}>
              <div className="d-flex align-items-center justify-content-center text-6F6B7D" style={{ fontSize: '14px', fontFamily: 'google sans, sans-serif' }}>
                <FontAwesomeIcon icon={faSpinner} className="me-2" spin />
                <span className="text-6F6B7D">กำลังตรวจสอบการชำระเงิน...</span>
              </div>
            </div>
          )}

          {/* Payment Amount */}
          <div className="mb-4 " style={{ borderRadius: '8px' }}>
            <div className="text-6F6B7D mb-1" style={{ fontSize: '14px', fontFamily: 'google sans, sans-serif' }}>
              จำนวนเงินที่ต้องชำระ
            </div>
            <div className="fw-bold" style={{ fontSize: '24px', color: '#10B981', fontFamily: 'google sans, sans-serif' }}>
              {dataList?.sumPaymentAmount || "0.00"} บาท
            </div>
          </div>

          {/* Download Button */}
          <button
            className="btn w-100 d-flex align-items-center justify-content-center "
            onClick={() => {
              // Download QR Code as JPG
              const img = new Image();
              img.crossOrigin = 'anonymous';
              img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                if (ctx) {
                  ctx.drawImage(img, 0, 0);
                  canvas.toBlob((blob) => {
                    if (blob) {
                      const url = URL.createObjectURL(blob);
                      const link = document.createElement('a');
                      link.href = url;
                      link.download = 'payment-qr-code.jpg';
                      link.click();
                      URL.revokeObjectURL(url);
                    }
                  }, 'image/jpeg', 0.5);
                }
              };
              img.onerror = () => {
                // Fallback: download original if conversion fails
                const link = document.createElement('a');
                link.href = qrCodeUrl;
                link.download = 'payment-qr-code.jpg';
                link.click();
              };
              img.src = qrCodeUrl;
            }}
            style={{
              backgroundColor: '#4263B5',
              color: '#FFFFFF',
              padding: '12px 20px',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              border: 'none',
              fontFamily: 'google sans, sans-serif'
            }}
          >
            <FontAwesomeIcon icon={faDownload} className="me-2" />
            <span>ดาวน์โหลด QR Code</span>
          </button>

          {/* Checking Status */}

        </div>
      </Dialog>
    </>
  );
};

const RecordInvoicePage = () => {
  return (
    <>
      <RecordInvoiceForm />
    </>
  );
};

export default RecordInvoicePage;
